import {useEffect, useState} from "react";
import {getAllDecisions, getDecisions} from "../services/api";
import {Link} from "react-router-dom";

export default function ListDecisions() {
    const [decisions, setDecisions] = useState([])
    const [showAll, setShowAll] = useState(false)
    
    const fetchDecisions = (includeAll) => {
        let funcPointer = getDecisions
        if (includeAll) {
            funcPointer = getAllDecisions
        }
        
        funcPointer()
            .then(apiDecisions => {
                setDecisions(apiDecisions)
            })
            .catch(ex => {
                console.log("Error getting decisions: ", ex)
            })
    }
    
    useEffect(() => {
        fetchDecisions(showAll)
    }, []);
    
    const toggleSetAll = () => {
        const newShowAll = !showAll
        setShowAll(newShowAll)
        
        
        fetchDecisions(newShowAll)
    }
    
    return (
        <>
            {decisions && <table className="table table-striped">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Probability</th>
                        <th>Pity</th>
                        <th>Guaranteed Date</th>
                        <th>Active</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                {decisions.map(d => {
                    return (
                        <tr key={d.decisionId}>
                            <td><Link to={`/decisions/${d.decisionId}`}>{d.name}</Link></td>
                            <td>{d.probability}</td>
                            <td>{d.pity}</td>
                            <td>{new Date(d.nextPick).toLocaleDateString()}</td>
                            <td>{d.activeFlag.toLocaleString()}</td>
                            <td>
                                <Link className="btn btn-sm btn-primary" to={`/decisions/${d.decisionId}/edit`}>Edit</Link>
                            </td>
                        </tr>
                    )
                })}
                </tbody>
            </table>}
            <div className={"mt-3"}>
                <Link className={"btn btn-primary"} to={"/decisions/new/edit"}>Add Decision</Link>
                <button className={"ms-3 btn btn-secondary"} onClick={toggleSetAll}>{showAll ? "Hide Inactive" : "Show Inactive"}</button>
            </div>
        </>
    )
}